export default "__VITE_ASSET__9568b200__"